var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-nav-bar',{staticClass:"nav",attrs:{"left-text":_vm.title,"left-arrow":"","fixed":""},on:{"click-left":_vm.onClickLeft}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }